export function generateDataTestId(testId, suffixes) {
  if (!testId) {
    return undefined;
  }
  if (!suffixes.length) {
    return testId;
  }
  return "".concat(testId, "-").concat(suffixes.join('-'));
}